import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    // Строка → NgbDateStruct
    parse(value: string): NgbDateStruct | null {
        if (!value) return null;
        const dt = new Date(value);
        if (isNaN(dt.getTime())) return null;
        return { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() };
    }

    // NgbDateStruct → "Jan 15, 2025"
    format(date: NgbDateStruct | null): string {
        if (!date) return '';
        const dt = new Date(date.year, date.month - 1, date.day);
        return dt.toLocaleDateString('en-US', {
            month: 'long', day: 'numeric', year: 'numeric'
        });
    }
}
